import React from "react";
import { AuthContext } from "../providers/auth";


export default function useAuth() {
  return React.useContext(AuthContext);
}